
import React from 'react';
import styles from './_finance-quoter-solve-button.module.scss';
import CalculateIcon from "@mui/icons-material/Calculate";
import {Button} from "@mui/material";
import { Tooltip } from "@progress/kendo-react-tooltip";
import {IApplication} from "../../../../Interfaces/Application/IApplication";
import {Vehicle} from "@amsanalytics/react-shared-library";

export interface FinanceQuoterSolveButtonProps {
  currentApp: IApplication;
  onSolve: (newVehicle: Vehicle | undefined) => void;
}

export default function FinanceQuoterSolveButton (props:  FinanceQuoterSolveButtonProps) {
  return (
    <div className={styles.financeQuoterSolveButtonContainer}>
      <Tooltip anchorElement="target" position="top" parentTitle={true}>
        <Button
          title={'Solve'}
          color="primary"
          variant='contained'
          startIcon={<CalculateIcon style={{marginRight: '-2px'}} fontSize='small' />}
          onClick={() => props.onSolve(undefined)}
          style={{padding: 3, paddingLeft: 10, paddingRight: 10, marginLeft: 4}}
        >
          Solve
        </Button>
      </Tooltip>
    </div>
  );
}
